<section class="cbanner bannerbgcolor position-relative">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"
			>
				<div class="banner vh-100">
					<div
						class="d-flex flex-column justify-content-center h-100 align-items-center text-center"
					>
						<div class="contentbl">
							<h1 class="light size90 textcolor1 mb-3 fontwg700">404</h1>
							<p class="size24 mb-3">the page you requested could not found</p>
							<a href="{{ baseUrl }}" class="btn btn-lg button size24"
								>Go to Home</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
